export const TYPES = {
  ALERT: 0,
  CONFIRM: 1,
  PROMPT: 2
}
